import { Box, Card, Grid, Tab, Tabs } from '@mui/material'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import { useCallback, useEffect, useRef, useState } from 'react'
import Calendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import timelinePlugin from '@fullcalendar/timeline'
import queryString from 'query-string'
import dayjs from 'dayjs'
import { CalendarContainer } from '../../../CRM/Features/Lead/Features/LeadCalender/components/CalendarContainer'
import { axiosInstance } from '../../../../hooks/useAxios'
import { DATE_FORMAT_INTERNATIONAL } from '../../../../constants/global'
import { numberFormat } from '../../../../utils'
import CalendarFilter, { EViewType } from './components/CalendarFilter'

const Menus: any[] = []

interface IOrderCalendar {
  pickUp: number
  pickUpCodAmount: number
  pickUpCod: number
  pickUpBankAmount: number
  pickUpBank: number
  success: number
  successCodAmount: number
  successCod: number
  successBank: number
  successBankAmount: number
  return: number
  returnCod: number
  returnCodAmount: number
  returnBank: number
  returnBankAmount: number
  date: string
}

const DailyCalendarOrderReportPage = () => {
  const queryStr = queryString.parse(window.location.search)
  const calendarRef = useRef<any>(null)
  const [date, setDate] = useState<Date>(new Date())
  const [view, setView] = useState<EViewType>(EViewType.MONTH)
  const [events, setEvents] = useState<{ title: string; date: string }[]>([])

  const [filter, setFilter] = useState<any>({
    trackingProvider: 'all',
  })

  useEffect(() => {
    onFilterChange(filter)
    getEvents()
  }, [filter])

  const getEvents = useCallback(async () => {
    try {
      const response = await axiosInstance.get<IOrderCalendar[]>(
        '/order/calendar',
        {
          params: {
            startDate: dayjs(
              filter?.startDate ?? dayjs().startOf('month'),
            ).format(DATE_FORMAT_INTERNATIONAL),
            endDate: dayjs(filter?.endDate ?? dayjs().endOf('month')).format(
              DATE_FORMAT_INTERNATIONAL,
            ),
            trackingProvider:
              filter?.trackingProvider === 'all'
                ? ''
                : filter?.trackingProvider,
          },
        },
      )
      const orders = response?.data ?? []
      const d: any[] = []

      orders.map((order: IOrderCalendar) => {
        d.push({
          title: `รับสินค้า ${numberFormat(
            order.pickUp,
          )} รายการ\nCOD: ${numberFormat(
            order.pickUpCodAmount,
          )} (${numberFormat(order.pickUpCod)})\nBank: ${numberFormat(
            order.pickUpBankAmount,
          )} (${numberFormat(order.pickUpBank)})`,
          color: '#104bb9',
          date: dayjs(order?.date).format(DATE_FORMAT_INTERNATIONAL),
        })
        d.push({
          title: `สำเร็จ ${numberFormat(
            order.success,
          )} รายการ\nCOD: ${numberFormat(
            order.successCodAmount,
          )} (${numberFormat(order.successCod)})\nBank: ${numberFormat(
            order.successBankAmount,
          )} (${numberFormat(order.successBank)})`,
          date: dayjs(order?.date).format(DATE_FORMAT_INTERNATIONAL),
        })
        d.push({
          title: `ตีกลับ ${numberFormat(
            order.return,
          )} รายการ\nCOD: ${numberFormat(
            order.returnCodAmount,
          )} (${numberFormat(order.returnCod)})\nBank:  ${numberFormat(
            order.returnBankAmount,
          )} (${numberFormat(order.returnBank)})\n`,
          color: '#f04438',
          date: dayjs(order?.date).format(DATE_FORMAT_INTERNATIONAL),
        })
      })
      setEvents(d)
      // console.log('d', d)
    } catch (e) {}
  }, [filter])

  const onFilterChange = useCallback(
    (newFilter: any) => {
      const newQuery = queryString.stringify({ ...newFilter })
      setFilter(newFilter)
    },
    [filter],
  )

  const handleViewChange = useCallback((view: EViewType) => {
    const calendarEl = calendarRef.current

    if (calendarEl) {
      const calendarApi = calendarEl.getApi()

      calendarApi.changeView(view)
      setView(view)
    }
  }, [])

  const handleDateNext = useCallback(() => {
    const calendarEl = calendarRef.current

    if (calendarEl) {
      const calendarApi = calendarEl.getApi()

      calendarApi.next()
      setDate(calendarApi.getDate())
      const d = calendarApi.getDate()
      onFilterChange({
        ...filter,
        startDate: dayjs(String(d)).startOf('month').format(),
        endDate: dayjs(String(d)).endOf('month').format(),
      })
    }
  }, [filter])

  const handleDatePrev = useCallback(() => {
    const calendarEl = calendarRef.current

    if (calendarEl) {
      const calendarApi = calendarEl.getApi()

      calendarApi.prev()
      setDate(calendarApi.getDate())
      const d = calendarApi.getDate()
      onFilterChange({
        ...filter,
        startDate: dayjs(String(d)).startOf('month').format(),
        endDate: dayjs(String(d)).endOf('month').format(),
      })
    }
  }, [filter])

  return (
    <ContentWrapper>
      <Helmet title="รายงานปฏิทินการส่งสินค้า" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายงานปฏิทินการส่งสินค้า"
            routes={Menus}
            descriptions="รายงานปฏิทินการส่งสินค้า"
          />
        </Grid>
      </Grid>
      <Card sx={{ padding: 2, mb: 3 }}>
        <CalendarFilter
          date={date}
          onDateNext={handleDateNext}
          onDatePrev={handleDatePrev}
          onViewChange={handleViewChange}
          setFilter={setFilter}
          filter={filter}
          view={view}
        />
        <CalendarContainer>
          <Calendar
            allDayMaintainDuration
            dayMaxEventRows={3}
            droppable={false}
            editable={false}
            eventDisplay="block"
            eventResizableFromStart
            eventOrder={`eventProperty`}
            // eventResize={handleEventResize}
            events={events}
            headerToolbar={false}
            height={900}
            initialDate={date}
            initialView={EViewType.MONTH}
            plugins={[
              dayGridPlugin,
              interactionPlugin,
              listPlugin,
              timeGridPlugin,
              timelinePlugin,
            ]}
            ref={calendarRef}
            rerenderDelay={10}
            // select={(e) => handleRangeSelect(e)}
            selectable
            eventContent={(eventInfo) => {
              return (
                <>
                  {eventInfo.event.title
                    .split('\n')
                    .map((line: string, index: number) => (
                      <div key={index}>{line}</div>
                    ))}
                </>
              )
            }}
            weekends
          />
        </CalendarContainer>
      </Card>
    </ContentWrapper>
  )
}

export default DailyCalendarOrderReportPage
